'use client'
import { AnimationOnScroll } from 'react-animation-on-scroll'

type WideBoxProps = {
  title: string
  animationProps: any
  borderColor?: string
}

const WideBox = ({
  title,
  children,
  animationProps,
  borderColor = '#266782',
}: React.PropsWithChildren<WideBoxProps>) => {
  return (
    <AnimationOnScroll
      {...animationProps}
      className="flex w-full flex-col border border-solid"
      style={{
        borderColor: borderColor,
        flexBasis: '100%',
        scrollSnapAlign: 'center',
      }}
    >
      <span className="w-full whitespace-pre-line px-6 py-4">{title}</span>
      <div className="flex flex-grow items-center justify-center">
        {children}
      </div>
    </AnimationOnScroll>
  )
}

export default WideBox
